import { SortingFn, sortingFns} from '@tanstack/react-table'
export const COLUMNS = (t:any,languages:any)=> [
  {
    header: t('profile.store.name'),
    accessorKey: 'name',
    cell: (info:any) =>  info.getValue()
      /* (languages.includes('ru') ? info.row.original.nameRU:info.row.original.nameEN)+`${info.row.original?.duration?.days ? ' '+t('defaults.time.days', {count: info.row.original.duration.days}):''}`, */
  },
  {
    header: t('profile.store.qnty'),
    accessorKey: 'qnty',
    cell: (info:any) => 'x'+new Intl.NumberFormat('ru-RU').format(info.getValue()),
    sortingFn: fuzzySort
  },
  {
    header: t('main.header.servers'),
    accessorKey: 'servers',
    cell: (info:any) => info.getValue(),
    sortingFn: fuzzySort
  },
  {
    header: t('profile.transactions.refund'),
    accessorKey: 'refundable',
    className: 'td_refund'
  }
]
export const getRolesCellClassName = (column:string, value:any) => {
  if (['amount'].includes(column)) {
    if (value > 0) {
      return `td_positive`;
    } else if (value < 0) {
      return `td_negative`;
    }
  }
  if (['refund'].includes(column)) return 'td_refund'
  return ""
}
const fuzzySort: SortingFn<any> = (rowA, rowB, columnId) => {
  return sortingFns.basic (rowA, rowB, columnId)
}